import React from "react";
import { MATERIALS } from "@/lib/brands";
import { Magnet, Zap } from "lucide-react";

const MaterialsList = ({ kind, data }) => (
  <div
    className="border border-black/15 bg-white p-8 md:p-10 relative"
    data-testid={`materials-${kind}`}
  >
    <div className="flex items-start justify-between mb-8">
      <div>
        <div className="eyebrow text-[color:var(--primary)] mb-2">
          {data.subtitle}
        </div>
        <h3 className="font-display text-3xl md:text-4xl uppercase leading-none">
          {data.title}
        </h3>
      </div>
      <div className="w-14 h-14 border-2 border-black grid place-items-center">
        {kind === "ferrous" ? <Magnet size={20} /> : <Zap size={20} />}
      </div>
    </div>
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-0">
      {data.items.map((m, i) => (
        <li
          key={m}
          className="py-3 border-t border-black/10 flex items-center justify-between text-sm"
        >
          <span>{m}</span>
          <span className="font-mono text-[10px] text-black/40">
            {String(i + 1).padStart(2, "0")}
          </span>
        </li>
      ))}
    </ul>
  </div>
);

const Materials = () => {
  return (
    <section
      id="materials"
      className="section-pad bg-[color:var(--bg-alt)] relative"
      data-testid="materials-section"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="eyebrow text-[color:var(--primary)] mb-4">
              ◆ What We Buy
            </div>
            <h2 className="font-display text-4xl md:text-6xl uppercase leading-[0.95] tracking-tighter">
              Every Grade. <br />
              <span className="text-[color:var(--accent)]">Fair Price.</span>
            </h2>
          </div>
          <p className="max-w-md text-black/60 text-sm leading-relaxed">
            We trade a full spectrum of ferrous and non-ferrous metals. All
            materials are priced on an individual basis — split loads always
            welcome. Pickup service available at no additional charge.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <MaterialsList kind="ferrous" data={MATERIALS.ferrous} />
          <MaterialsList kind="non_ferrous" data={MATERIALS.non_ferrous} />
        </div>
      </div>
    </section>
  );
};

export default Materials;
